import {Injectable} from '@angular/core';
import {ApiOperadorRepository} from "./api/operador/api.operador.repository";
import {ApiBookingRepository} from "./api/booking/api.booking.repository";
import {environment} from "../../../environments/environment";
import {SharedService} from "./shared.service";

@Injectable({
    providedIn: 'root'
})
export class GlobalDataService {


    public dataViajeList: any[] = [];
    private dataLocalList: any[] = [];

    constructor(
        private _apiOperadorRepository: ApiOperadorRepository,
        private _apiBookingRepository: ApiBookingRepository,
        private sharedService: SharedService
    ) {
    }

    public async _init(){
        await this.getDataLocalList();
        await this.getTipoContenedorUserList();
        await this.getDataClienteList();
        await this.getDataNaveList();
        await this.getDataLineaList();
    }

    public async getDataClienteList() {
       const response = await this._apiOperadorRepository.buscarClientesPorTexto(-1);
       this.sharedService.setDataClienteList(response.data);
    }

    public async getDataNaveList() {
       const response = await this._apiBookingRepository.getNavesAll();
       this.sharedService.setDataNaveList(response.data);
    }

    public async getDataViajeListByNave(nave_id: any) {
       const response = await this._apiBookingRepository.getViajeAllByNave(nave_id);
       this.dataViajeList = response.data;
    }

    public async getDataLineaList() {
        const response = await this._apiBookingRepository.getLineasAll();
        this.sharedService.setDataLineaList(response.data);
    }

    public async getDataTipoContenedorList() {
        const response = await this._apiBookingRepository.getListTipoContenedor();
        this.sharedService.setDataTipoContenedorList(response.data);
    }

    public async getTipoContenedorUserList() {
        const response = await this._apiBookingRepository.getListTipoContenedorUser();
        this.sharedService.setDataTipoContenedorUserList(response.data);
    }

    public async getDataLocalList() {
        //this.dataLocalList.length = 0;
        this.dataLocalList = [
            {
                local_id: environment.PARAM.TODOS,
                local_descripcion: "TODAS JURISDICCIÓNES",
            }
        ];
        const response = await this._apiBookingRepository.getLocales();
        const dataLocalList = response.data;

        if(dataLocalList){
            if(dataLocalList.length > 0){
                this.dataLocalList = [...this.dataLocalList, ...dataLocalList]
            }
        }

        this.sharedService.setDataLocalList(this.dataLocalList);


    }
}

